/* eslint-disable */

import "./Multiselectjquery.css";
import "sweetalert2/src/sweetalert2.scss";

import * as $ from "jquery";

import { NavLink, Route, BrowserRouter as Router } from "react-router-dom";
import React, { Suspense, lazy } from "react";

import CryptoJS from "crypto-js";
import { LoadingPage } from "./LoadingPage";
import ReactDOM from "react-dom";
import { Service } from "./DBService/DBService";
import Swal from "sweetalert2/dist/sweetalert2.js";
import registerServiceWorker from "./registerServiceWorker";

const New_tictoksnav_bar = lazy(() => import("./New_tictoksnav_bar"));
const GstdashboardPremium = lazy(() => import("./GstdashboardPremium"));
const GstdashboardBasic = lazy(() => import("./GstdashboardBasic"));
const FooterText = lazy(() => import("./FooterText"));
const SignIn = lazy(() => import("./SignIn"));
const ForgotPassword = lazy(() => import("./ForgotPassword"));
const QRCodeScanner = lazy(() => import("./QRCode_Attendance/QRCode Scanner"));

const OTPVerification = lazy(() => import("./QRCode_Attendance/Verfication/OTPVerfication"));

var profileStatusData;

export const LoginFunc = function(stateData) {
  /*   console.log("LOGIN FUNC ****** ",stateData);
      console.log("LOGIN FUNC EMAIL-ID",stateData.emailId);
    console.log("LOGIN FUNC PASSWORD",stateData.password);
    */
  var encrypted = "ThirdPartySignIn";
  if (stateData.password != "ThirdPartySignIn") {
    var secret = "ShinchanThroughAppsShinchanThroughApps";
    encrypted = CryptoJS.AES.encrypt(stateData.password, secret);
    encrypted = encrypted.toString();

    var key = "shinchanbaby";

    // localStorage.setItem('EmailId', CryptoJS.AES.encrypt(stateData.emailId, key));
    //  localStorage.setItem('Password', CryptoJS.AES.encrypt(encrypted, key));
  }

  var self = this;
  $.ajax({
    type: "POST",
    data: JSON.stringify({
      emailId: stateData.emailId,
      password: encrypted,
    }),
    //ACTUAL URL
    url: serverUrl + "/EmployeeAttendenceAPI/employee/employeeLogin",
    //url: "http://localhost:8080/EmployeeAttendenceAPI/employee/employeeLogin",

    contentType: "application/json",
    dataType: "json",
    async: false,
    crossDomain: true,
    success: function(data, textStatus, jqXHR) {

      var orgAttendanceType=data.orgAttendanceType.split(",");

      window.scrollTo(0, 0);
      console.log("data ", data);

      //  localStorage.setItem('ProfileStatusData', CryptoJS.AES.encrypt(data.profileStatus, key));
      var key = "shinchanbaby";
      localStorage.setItem("ProfileStatusData", CryptoJS.AES.encrypt("1", key));

      if (data.employeeId == "NOT_REGISTERED") {
        Swal.fire({
          position: "center",
          icon: "warning",
          text: "Please Register to Login",
          timer: 3000,
        });

        ReactDOM.render(
          <Router>
            <Suspense fallback={<LoadingPage />}>
              <div>
                <Route path="/" component={SignIn} />
              </div>
            </Suspense>
          </Router>,
          document.getElementById("root")
        );
        registerServiceWorker();
      } else if (data.employeeId == "PASSWORD_INCORRECT") {
        Swal.fire({
          position: "center",
          icon: "warning",
          text:
            "Incorrect Password.Enter Correct Password or Click on Forgot Password to reset", // Message dialog
          timer: 3000,
        });

        ReactDOM.render(
          <Router>
            <Suspense fallback={<LoadingPage />}>
              <div>
                <Route path="/" component={SignIn} />
              </div>
            </Suspense>
          </Router>,
          document.getElementById("root")
        );
        registerServiceWorker();
      } else if (data.employeeId == "LOCKED") {
        Swal.fire({
          position: "center",
          icon: "warning",
          text: "Your ID has been Locked,Please contact Admin",
          timer: 3000,
        });

        ReactDOM.render(
          <Router>
            <Suspense fallback={<LoadingPage />}>
              <div>
                <Route path="/" component={SignIn} />
              </div>
            </Suspense>
          </Router>,
          document.getElementById("root")
        );
        registerServiceWorker();
      } else if (data.employeeId == "BLOCKED") {
        Swal.fire({
          position: "center",
          icon: "warning",
          text: "Your ID Has Been Blocked, Please contact Admin",
          timer: 3000,
        });
        ReactDOM.render(
          <Router>
            <Suspense fallback={<LoadingPage />}>
              <div>
                <Route path="/" component={SignIn} />
              </div>
            </Suspense>
          </Router>,
          document.getElementById("root")
        );
        registerServiceWorker();
      } else {
        if (navigator.onLine) {
          if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
              successFunction,
              errorFunction
            );
          } else {
            //	alert("Geolocation is Not supported by this Browser");
          }
        }
        //Get the latitude and the longitude;
        function successFunction(position) {
          var lat = position.coords.latitude;
          var lng = position.coords.longitude;
          //console.log("succ",position)
          codeLatLng(lat, lng);
        }

        function errorFunction() {
          //alert("Geocoder failed");
        }

        function codeLatLng(lat, lng) {
          $.ajax({
            type: "GET",
            url:
              "https://maps.googleapis.com/maps/api/geocode/json?latlng=" +
              lat +
              "," +
              lng +
              "&sensor=true",
            success: function(data) {
              //console.log("full",data,"status",data.status)
              localStorage.setItem("Location", "-");
              if (data.status == "OK") {
                //console.log("full address",data.results[0].formatted_address);
                //console.log("main Address",data.results[0].address_components[1].long_name,",",data.results[0].address_components[2].long_name);
                var loca =
                  data.results[0].address_components[1].long_name +
                  "," +
                  data.results[0].address_components[2].long_name;
                localStorage.setItem("Location", loca);
              }
            },
          });
        }
        Service.getAll("ProfileImage", "employeeId", []).then((status) => {
          console.log("stattus ", status);
          if (status) {
            if (status.companyId !== data.companyId) {
              console.log("delete data company id difference");
              Service.deleteAll("ProfileImage").then((delStatus) => {
                console.log("Deleted Status ", delStatus);
              });
            }
          }
        });
        var key = "shinchanbaby";
        localStorage.setItem(
          "WorkSite",
          CryptoJS.AES.encrypt(data.workSite, key)
        );
        localStorage.setItem(
          "SiteDetails",
          CryptoJS.AES.encrypt(JSON.stringify(data.siteDetailsList), key)
        );
        localStorage.setItem("EmpTimeZone", data.timeZone);
        localStorage.setItem(
          "isLoggedIn",
          CryptoJS.AES.encrypt("true".toString(), key)
        );
        localStorage.setItem(
          "Departments",
          CryptoJS.AES.encrypt(JSON.stringify(data.employeeDepartmentlist), key)
        );
        localStorage.setItem(
          "Roles",
          CryptoJS.AES.encrypt(JSON.stringify(data.employeeRolelist), key)
        );
        localStorage.setItem(
          "Permissions",
          CryptoJS.AES.encrypt(JSON.stringify(data.employeePermisionlist), key)
        );
        localStorage.setItem(
          "PermissionHeader",
          CryptoJS.AES.encrypt(JSON.stringify(data.headerPermissionList), key)
        );
        localStorage.setItem("Role", CryptoJS.AES.encrypt(data.role, key));
        localStorage.setItem(
          "EmployeeId",
          CryptoJS.AES.encrypt(data.employeeId, key)
        );
        localStorage.setItem(
          "EmpList",
          CryptoJS.AES.encrypt(JSON.stringify(data.employeeList), key)
        );
        localStorage.setItem(
          "LockList",
          CryptoJS.AES.encrypt(JSON.stringify(data.lockList), key)
        );
        localStorage.setItem(
          "CompanyId",
          CryptoJS.AES.encrypt(data.companyId, key)
        );
        localStorage.setItem(
          "CompanyName",
          CryptoJS.AES.encrypt(data.companyName, key)
        );
        localStorage.setItem(
          "EmployeeName",
          CryptoJS.AES.encrypt(data.userName, key)
        );
        localStorage.setItem(
          "Department",
          CryptoJS.AES.encrypt(data.department, key)
        );
        localStorage.setItem(
          "ReportingManagerList",
          CryptoJS.AES.encrypt(JSON.stringify(data.reportingManagerList), key)
        );
        localStorage.setItem(
          "BiometricValue",
          CryptoJS.AES.encrypt(data.biometricValue.toString(), key)
        );
        localStorage.setItem(
          "ShiftMode",
          CryptoJS.AES.encrypt(data.shiftMode.toString(), key)
        );
        localStorage.setItem(
          "CompanyType",
          CryptoJS.AES.encrypt(data.companyType, key)
        );
        localStorage.setItem(
          "SMS",
          CryptoJS.AES.encrypt(data.sms.toString(), key)
        );
        localStorage.setItem(
          "PlanName",
          CryptoJS.AES.encrypt(data.planName, key)
        );
        localStorage.setItem(
          "WifiSetting",
          CryptoJS.AES.encrypt(data.wifiSetting, key)
        );
        localStorage.setItem(
          "SalarySelectionOption",
          CryptoJS.AES.encrypt(data.salarySelectionOption, key)
        );
        localStorage.setItem(
          "FirstCheckInLastCheckOut",
          CryptoJS.AES.encrypt(data.firstCheckinlastCheckout, key)
        );
        localStorage.setItem("Trial", CryptoJS.AES.encrypt(data.trial, key));
        localStorage.setItem(
          "Active",
          CryptoJS.AES.encrypt(data.activeStatus, key)
        );
        localStorage.setItem(
          "TrialCount",
          CryptoJS.AES.encrypt(data.alertNo, key)
        );
        localStorage.setItem("GSTIN", CryptoJS.AES.encrypt(data.gstin, key));
        localStorage.setItem(
          "ProductiveApps",
          CryptoJS.AES.encrypt(data.productiveApps, key)
        );
        localStorage.setItem(
          "NonProductiveApps",
          CryptoJS.AES.encrypt(data.nonproductiveApps, key)
        );
        localStorage.setItem(
          "ProductiveSites",
          CryptoJS.AES.encrypt(data.productiveSites, key)
        );
        localStorage.setItem(
          "NonProductiveSites",
          CryptoJS.AES.encrypt(data.nonproductiveSites, key)
        );
        localStorage.setItem(
          "WebCheckInFace",
          CryptoJS.AES.encrypt(data.webCheckInFace, key)
        );
        localStorage.setItem(
          "WebCheckInLocation",
          CryptoJS.AES.encrypt(data.webCheckInLocation, key)
        );

        localStorage.setItem(
          "FaceCheckIn",
          CryptoJS.AES.encrypt(data.faceCheckIn, key)
        );
        localStorage.setItem("AwsBucketName", data.awsBucketName);
        localStorage.setItem("AwsRegion", data.awsRegion);
        localStorage.setItem("AwsAccessKeyId", data.awsAccessKeyId);
        localStorage.setItem("AwsSecretAccessKey", data.awsSecretAccessKey);
        localStorage.setItem(
          "StorageType",
          CryptoJS.AES.encrypt(data.storageType, key)
        );
        localStorage.setItem(
          "ProfileImageName",
          CryptoJS.AES.encrypt(data.profileImage, key)
        );

        // localStorage.setItem('ThirdPartyLogin', CryptoJS.AES.encrypt(data.thirdPartyLogin, key));
        localStorage.setItem(
          "ProfileStatusData",
          CryptoJS.AES.encrypt(data.profileStatus.toString(), key)
        );

        localStorage.setItem(
          "EmailId",
          CryptoJS.AES.encrypt(data.emailId, key)
        );
        localStorage.setItem(
          "Password",
          CryptoJS.AES.encrypt(data.password, key)
        );
        localStorage.setItem(
          "OrgAttendanceType",
          CryptoJS.AES.encrypt(data.orgAttendanceType , key)
        );
        localStorage.setItem(
          "QROTP_Status",
          CryptoJS.AES.encrypt(data.QROTP , key)
        );
        

        if (data.file === "NO_FILE") {
          localStorage.setItem(
            "GoogleAPIKey",
            CryptoJS.AES.encrypt(JSON.stringify(data.file), key)
          );
        } else {
          localStorage.setItem(
            "GoogleAPIKey",
            CryptoJS.AES.encrypt(JSON.stringify(JSON.parse(data.file)), key)
          );
        } //console.log("google api key ",data.file);
        /* self.saveTextAsFile();
         */ var planName = CryptoJS.AES.decrypt(
          localStorage.getItem("PlanName"),
          "shinchanbaby"
        ).toString(CryptoJS.enc.Utf8);
        if (
          window.location.pathname === "/Signup" ||
          window.location.pathname === "/signup"
        ) {
          var url_string = window.location.href;
          var newurl = "/";
          window.history.replaceState({}, document.title, newurl);
        }

        //New_tictoksnav_bar.ProfileStatusFunc(0);

        if (planName.toLowerCase() == "basic") {
          console.log("basicplan", planName);

          ReactDOM.render(
            <Router>
              <Suspense fallback={<LoadingPage />}>
                <div>
                  <Route path="/" component={GstdashboardBasic} />
                  {/* <Route exact path="/Attendence" component={Attendence} />
                            <Route exact path="/Charts" component={Charts} />
                            <Route exact path="/AttendanceDisplay" component={AttendanceDisplay} />
                            <Route exact path="/AddEmployee" component={AddEmployee} />
                            <Route exact path="/SearchEmployee" component={SearchEmployee} />
                            <Route exact path="/UpdateEmployee" component={UpdateEmployee} />
                            <Route exact path="/EmployeeAttendanceRequest*" component={EmployeeRequestAcceptReject} />
                            <Route exact path="/EmployeeLeaveRequest/*" component={EmployeeRequestAcceptReject} />
                            <Route exact path="/LoginIssuePage/*" component={LoginIssuePage} />
                            <Route exact path="/DeviceIssuePage/*" component={DeviceIssuePage} />
                            <Route exact path="/CheckinIssuePage/*" component={CheckinIssuePage} />
                            <Route exact path="/TicketReopenPage/*" component={TicketReopenPage} />
*/}{" "}
                  <Route
                    exact
                    path="/ForgotPassword"
                    component={ForgotPassword}
                  />
                  <Route path="/" component={FooterText} />
                </div>
              </Suspense>
            </Router>,
            document.getElementById("root")
          );
          registerServiceWorker();
        } else if (planName.toLowerCase() == "premium") {
          console.log("premiumplan", planName);
          ReactDOM.render(
            <Router>
              <Suspense fallback={<LoadingPage />}>
                <div>
                  <Route path="/" component={GstdashboardPremium} />
                  {/* 	<Route exact path="/Attendence" component={Attendence} />
                            <Route exact path="/Charts" component={Charts} />
                            <Route exact path="/AttendanceDisplay" component={AttendanceDisplay} />
                            <Route exact path="/AddEmployee" component={AddEmployee} />
                            <Route exact path="/SearchEmployee" component={SearchEmployee} />
                            <Route exact path="/UpdateEmployee" component={UpdateEmployee} />
                            <Route exact path="/EmployeeAttendanceRequest/*" component={EmployeeRequestAcceptReject} />
                            <Route exact path="/EmployeeLeaveRequest/*" component={EmployeeRequestAcceptReject} />
                            <Route exact path="/LoginIssuePage/*" component={LoginIssuePage} />
                            <Route exact path="/DeviceIssuePage/*" component={DeviceIssuePage} />
                            <Route exact path="/CheckinIssuePage/*" component={CheckinIssuePage} />
                            <Route exact path="/TicketReopenPage/*" component={TicketReopenPage} />
                         */}{" "}
                  <Route
                    exact
                    path="/ForgotPassword"
                    component={ForgotPassword}
                  />
                  <Route path="/" component={FooterText} />
                </div>
              </Suspense>
            </Router>,
            document.getElementById("root")
          );
          registerServiceWorker();
        } else if (planName.toLowerCase() == "elite") {
          if (data.role == "QR_SCANNER") {
          //  alert("SCANNER");

            ReactDOM.render(
                <Router>
                  <Suspense fallback={<LoadingPage />}>
                    <div>
                      <Route path="/" component={QRCodeScanner} />
                    </div>
                  </Suspense>
                </Router>,
                document.getElementById("root")
              );
              

          } else if (orgAttendanceType.includes("QrCode") && data.role!="Director" && data.role!="TAPropertier") {
          //  alert("org type qr");
            ReactDOM.render(
                <Router>
                  <Suspense fallback={<LoadingPage />}>
                    <div>
                      <Route path="/" component={OTPVerification} />
                    </div>
                  </Suspense>
                </Router>,
                document.getElementById("root")
              );
              
          } else {
          //  alert("not scanner & qrcode");
            console.log("eliteplan", planName.toLowerCase());

            ReactDOM.render(
              <Router>
                <Suspense fallback={<LoadingPage />}>
                  <div>
                    <Route
                      path="/"
                      component={New_tictoksnav_bar}
                      data={profileStatusData}
                    />
                    {/* 
                            <Route exact path="/" component={GstdashboardElite} />
                            <Route exact path="/Attendence" component={Attendence} />
                            <Route exact path="/Charts" component={Charts} />
                            <Route exact path="/AttendanceDisplay" component={AttendanceDisplay} />
                            <Route exact path="/AddEmployee" component={AddEmployee} />
                            <Route exact path="/SearchEmployee" component={SearchEmployee} />
                            <Route exact path="/UpdateEmployee" component={UpdateEmployee} />
                            <Route exact path="/EmployeeAttendanceRequest/*" component={EmployeeRequestAcceptReject} />
                            <Route exact path="/EmployeeLeaveRequest/*" component={EmployeeRequestAcceptReject} />
                            <Route exact path="/LoginIssuePage/*" component={LoginIssuePage} />
                            <Route exact path="/DeviceIssuePage/*" component={DeviceIssuePage} />
                            <Route exact path="/CheckinIssuePage/*" component={CheckinIssuePage} />
                            <Route exact path="/TicketReopenPage/*" component={TicketReopenPage} />
                        */}{" "}
                    <Route
                      exact
                      path="/ForgotPassword"
                      component={ForgotPassword}
                    />
                    <Route path="/" component={FooterText} />
                  </div>
                </Suspense>
              </Router>,
              document.getElementById("root")
            );
            registerServiceWorker();
          }
        }
      }
    },

    error: function(data) {
      Swal.fire({
        position: "center",
        icon: "error",
        title: "No Internet",
        text: "Network Connection Problem",
        timer: 3000,
      });
    },
  });
};
